import { useState, useEffect } from 'react'
import { Auth } from 'aws-amplify'
import axios from 'axios'
import AdjustmentList from './AdjustmentList'

const AdjustmentReasons = () => {
    const [adjustmentData, setAdjustmentData] = useState([])
    const [errorMsg, setErrorMsg] = useState('')
    const [loading, setLoading] = useState(false)
    const [saving, setSaving] = useState(false)
    const [adding, setAdding] = useState(false)
    const [newAdjustmentReason, setNewAdjustmentReason] = useState(null)

    useEffect (() => {
      getAdjustmentReasons()
    }, [])

    const getAdjustmentReasons = async () => {

        setErrorMsg('')
        setLoading(true)
        setAdjustmentData([])
        let session = await Auth.currentSession()
        let jwt = session.getIdToken().getJwtToken()

        axios
        .get(`${process.env.REACT_APP_API_URL}/adjustmentreasons`,
        {headers: {Authorization: jwt}}
        )
        .then(response => {
            setAdjustmentData(response.data.rows)
            setLoading(false)
            console.log('WHATS HERE: ', adjustmentData)
        })
        .catch(error => {
            console.log('The error is: ', error)
            setErrorMsg('Problem retrieving data: ', error)
            setLoading(false)
        })            
    }

    const addNewClick = () => {
      setAdding(true)
    }

    const onCancelClick = () => {
      setNewAdjustmentReason(null)
      setAdding(false)
    }

    const saveAdjustmentReason = async (e) => {
      e.preventDefault()

      setErrorMsg('')
      setSaving(true)
      let session = await Auth.currentSession()
      let jwt = session.getIdToken().getJwtToken()
      axios
          .put(`${process.env.REACT_APP_API_URL}/adjustmentreasons`, {updateType: 'insert', adjustmentReason: newAdjustmentReason},
          {headers: {Authorization: jwt}}
          )
          .then(response => {
              setAdjustmentData(response.data.rows.map(newAdjustmentItem => {
                  return newAdjustmentItem
              }))
              setSaving(false)
              setNewAdjustmentReason(null)
              setAdding(false)
          })
          .catch(error => {
              console.log('The error is: ', error)
              setErrorMsg('Problem saving data: ', error)
              setSaving(false)
          })            
    }

    return (
        <div className="report">
          <h2>Adjustment Reasons</h2>
          { loading && <h3>Loading...</h3>}
          {errorMsg && <p className="form__error">{errorMsg}</p>}
          {!adding && <button className="button" onClick={addNewClick} disabled={loading || adding}>Add New</button>}
          {adding && <div>
            <h4>New Adjustment Reason:</h4>
            { saving && <h3>Saving...</h3>}
            <table className="styled-table">
              <thead>
                <tr>
                  <th>Adjustment Reason</th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <input 
                    type="text"
                    min="0"
                    className="text-input__customer-add"
                    name="adjustmentReason"
                    value={newAdjustmentReason}
                    disabled={saving}
                    onChange={e => setNewAdjustmentReason(e.target.value) } />
                  </td>
                  <td>
                    <button className="table-button" onClick={onCancelClick} disabled={saving}>Cancel</button>
                  </td>
                  <td>
                    <button className="table-button" onClick={saveAdjustmentReason} disabled={saving || !newAdjustmentReason} >Add</button>
                  </td>
                </tr>
              </tbody>
            </table>              
          </div>}
          {adjustmentData.length > 0 && <div >
            <h4>Current Adjustment Reasons:</h4>
            <table className="styled-table styled-table__fixed">
              <thead>
                  <tr>
                      <th>Adjustment Reason</th>
                      <th></th>
                      <th></th>
                  </tr>
              </thead>
              <tbody>
                {adjustmentData.map((adjustmentItem) => (
                  <AdjustmentList
                    key={adjustmentItem.id}
                    adjustmentItem={adjustmentItem}
                    setAdjustmentData={setAdjustmentData}
                    setErrorMsg={setErrorMsg}
                  />
                ))}
              </tbody>
            </table>
          </div>}
        </div>
    )
}

export default AdjustmentReasons